// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WyML","left":"styles_left__2NbDF"};